import { CSSProperties, useState } from "react";
import Columns from "../../../library/components/layout/Columns";
import Rows from "../../../library/components/layout/Rows";
import { Button } from "@mui/material";
import { appIcons } from "../../../app/appIcons";
import CsmTextField from "../../../library/components/mui/common/CsmTextField";
import GenelDurumHelper from "../../../helpers/GenelDurumHelper";
import Cell from "../../../library/components/layout/Cell";
import { useScreenWidth } from "../../../library/components/hooks/useScreenWidth";
import { SarkiZorlukModel } from "../../../models/businessModels/SarkiZorlukModel";
import { SarkiModel } from "../../../models/businessModels/SarkiModel";
import DateTimeHelper from "../../../library/helpers/DateTimeHelper";
import { WithParentIdRequestModel } from "../../../models/requestModels/WithParentIdRequestModel";
import JsonHelper from "../../../library/helpers/JsonHelper";
import CsmFormSegmentedRadioButtonList from "../../../library/components/mui/radio/CsmFormSegmentedRadioButtonList";
import CsmGenericGroupBox from "../../../library/components/mui/CsmGenericGroupBox";
import { BusinessHelper } from "../../../helpers/BusinessHelper";
import { CsmText } from "../../../library/components/mui/CsmText";
import appColors from "../../../app/appColors";
import VatanZorlukSlider from "../../../components/vatan/VatanZorlukSlider";
import { GuidHelper } from "../../../library/helpers/GuidHelper";
import CsmGradientProgress from "../../../library/components/mui/CsmGradientProgress";
import StringHelper from "../../../library/helpers/StringHelper";
// import { Radar } from "react-chartjs-2";
// import { ArcElement, Chart, LineElement, PointElement, PolarAreaController, RadialLinearScale } from "chart.js";

// "chart.js": "^4.0.0",
// "react-chartjs-2": "^5.2.0",

interface ISarkiZorlukSarkiPopupEditorProps {
    sarkiModel: SarkiModel,
    sarkiZorlukModel: SarkiZorlukModel | null,
    guncellenebilir?: boolean,
    closer: (model: SarkiZorlukModel | null) => void,
    genelDurumHelper: GenelDurumHelper,
}

function SarkiZorlukSarkiPopupEditor(props: ISarkiZorlukSarkiPopupEditorProps) {
    const { guncellenebilir, sarkiModel, closer, genelDurumHelper } = props;
    const [zorlukModel, setZorlukModel] = useState<SarkiZorlukModel>(props.sarkiZorlukModel ?? new SarkiZorlukModel());

    // Chart.register(PolarAreaController, RadialLinearScale, PointElement, LineElement, ArcElement);

    const zorlukKaydet = async () => {

        const guncellemeMi = props.sarkiZorlukModel !== null;

        if (!guncellemeMi) {
            zorlukModel.id = GuidHelper.NewGuid(),
                zorlukModel.olusturan = genelDurumHelper.SeciliKullanici.kullaniciAdi;
            zorlukModel.olusturmaTarih = DateTimeHelper.now();
            zorlukModel.sarkiModelId = sarkiModel.id;
        }

        const requestModel = new WithParentIdRequestModel<SarkiZorlukModel>(zorlukModel, sarkiModel.id);
        const webResponse = guncellemeMi ? await genelDurumHelper.requestHelper.YonetimSarkiZorluk.ZorlukGuncelle(requestModel) : await genelDurumHelper.requestHelper.YonetimSarkiZorluk.ZorlukEkle(requestModel);
        if (!webResponse.successfull)
            return;

        closer(zorlukModel);
    }

    const zorlukBilgiChanged = (action: (model: SarkiZorlukModel) => void): void => {
        const dummy = JsonHelper.deepCopy(zorlukModel);
        action(dummy);
        setZorlukModel(dummy);
    }

    const screenSize = useScreenWidth();
    const isSmallScreen = screenSize === "Max300";
    const isMediumScreen = screenSize === "Max600";
    const isLargeScreen = screenSize === "Max900";
    const isXLargeScreen = screenSize === "Max1200";

    const minWidth = isSmallScreen ? 250 : isMediumScreen ? 250 : isLargeScreen ? 550 : isXLargeScreen ? 850 : 1150;

    const zorlukList = [{ title: "Belirlenmedi", value: -1 }, { title: "Uygun", value: 1 }, { title: "Uygun Değil", value: 0 }];

    const zorlukToZorlukNumber = (value: boolean | null): number => value === true ? 1 : value === false ? 0 : -1;
    const zorlukNumberToZorluk = (value: number | null) => (value === -1 || value === undefined) ? null : value === 1 ? true : false;

    const currentStats = BusinessHelper.SarkiZorluk.StatOlustur(sarkiModel, zorlukModel);

    const uygunlukVeYorumContent = <Rows flex>
        <Columns ml={3}>
            <CsmGenericGroupBox label="Eser Koroya uygun mu">
                <CsmFormSegmentedRadioButtonList
                    disabled={!guncellenebilir}
                    value={zorlukToZorlukNumber(zorlukModel.koroyaUygunluk)}
                    list={zorlukList}
                    labelGetter={e => e.title}
                    valueGetter={e => e.value}
                    onChange={e => zorlukBilgiChanged(t => t.koroyaUygunluk = zorlukNumberToZorluk(e))}
                    style={{ marginBottom: "-5px" }}
                />
            </CsmGenericGroupBox>
            <Cell flex style={{ placeContent: "center", display: "flex" }}>
                {zorlukModel.koroyaUygunluk === null ? appIcons.Zorluk.bilinmiyor_maxi : zorlukModel.koroyaUygunluk === true ? appIcons.Zorluk.uygun_maxi : appIcons.Zorluk.uygunDegil_maxi}
            </Cell>
        </Columns>
        <Cell style={{ margin: "5px" }}>
            <CsmTextField
                disabled={!guncellenebilir}
                label="Yorumlar"
                multiline
                rows={2}
                showStats
                appendMaxlenOnLabel={4000}
                value={zorlukModel.yorumlar}
                onChange={e => zorlukBilgiChanged(t => t.yorumlar = e)} />
        </Cell>
    </Rows>

    const ogrenmeZorlukStatContent = <Rows>
        <CsmText header>Öğrenme Zorlukları</CsmText>
        <StatLine title="Eser Uzunluğu" note={StringHelper.isEmpty(sarkiModel.olcuSayisi) ? "" : `(${sarkiModel.olcuSayisi} Ölçü)`} value={currentStats.eserUzunluk} />
        <StatLine title="Eser Dili" note={StringHelper.isEmpty(sarkiModel.dil) ? "" : `(${sarkiModel.dil})`} value={currentStats.eserDil} />
        <StatLine title="Armoni/Ton Değişiklikleri" value={currentStats.armoni} />
        <StatLine title="Melodi/Yatay Zorluk" value={currentStats.melodi} />
        <StatLine title="Divizi" value={currentStats.divizi} note={sarkiModel.sesGrupIdList.length === 0 ? "" : `(${BusinessHelper.SesGrubu.IdListtenSATBUret(genelDurumHelper.SeciliKoroModel.tumSesGruplari, sarkiModel.sesGrupIdList)})`} />
        <StatLine title="Ortalama" value={currentStats.ortalamaOgrenme} ortalama />
    </Rows>

    const soylemeZorlukStatContent = <Rows>
        <CsmText header>Söyleme Zorlukları</CsmText>
        <StatLine title="Ses Sınırı" value={currentStats.sesSinir} />
        <StatLine title="Nüanslar" value={currentStats.nuans} />
        <StatLine title="Duygu" value={currentStats.duygu} />
        <StatLine title="Nefes/Teknik" value={currentStats.nefesTeknik} />
        <StatLine title="Ortalama" value={currentStats.ortalamaSoyleme} ortalama />
    </Rows>

    const legendContent = <Rows>
        <CsmText header>Skala</CsmText>
        <LinearBoxWithText title="1 - Çok Kolay" percent={10} />
        <LinearBoxWithText title="2-3 - Kolay" percent={25} />
        <LinearBoxWithText title="4-5 - Orta" percent={45} />
        <LinearBoxWithText title="6-7 - zor" percent={65} />
        <LinearBoxWithText title="8-9 - Çok Zor" percent={80} />
        <LinearBoxWithText title="10 - İmkansız" percent={100} />
    </Rows>

    const inputlarContent = <Columns wrap>
        <Cell width={240} style={{ margin: "5px" }}>
            <CsmGenericGroupBox label="Armoni / Ton Değişiklkleri">
                <VatanZorlukSlider disabled={!guncellenebilir} value={zorlukModel.armoniTon} onChange={e => zorlukBilgiChanged(t => t.armoniTon = e)} allowNull />
            </CsmGenericGroupBox>
        </Cell>
        <Cell width={240} style={{ margin: "5px" }}>
            <CsmGenericGroupBox label="Ses Sınırı">
                <VatanZorlukSlider disabled={!guncellenebilir} value={zorlukModel.sesSiniri} onChange={e => zorlukBilgiChanged(t => t.sesSiniri = e)} allowNull />
            </CsmGenericGroupBox>
        </Cell>
        <Cell width={240} style={{ margin: "5px" }}>
            <CsmGenericGroupBox label="Nüans">
                <VatanZorlukSlider disabled={!guncellenebilir} value={zorlukModel.nuanslar} onChange={e => zorlukBilgiChanged(t => t.nuanslar = e)} allowNull />
            </CsmGenericGroupBox>
        </Cell>
        <Cell width={240} style={{ margin: "5px" }}>
            <CsmGenericGroupBox label="Melodi / Yatay Zorluk">
                <VatanZorlukSlider disabled={!guncellenebilir} value={zorlukModel.melodi} onChange={e => zorlukBilgiChanged(t => t.melodi = e)} allowNull />
            </CsmGenericGroupBox>
        </Cell>
        <Cell width={240} style={{ margin: "5px" }}>
            <CsmGenericGroupBox label="Duygu">
                <VatanZorlukSlider disabled={!guncellenebilir} value={zorlukModel.duygu} onChange={e => zorlukBilgiChanged(t => t.duygu = e)} allowNull />
            </CsmGenericGroupBox>
        </Cell>
        <Cell width={240} style={{ margin: "5px" }}>
            <CsmGenericGroupBox label="Nefes / Teknik">
                <VatanZorlukSlider disabled={!guncellenebilir} value={zorlukModel.nefesTeknik} onChange={e => zorlukBilgiChanged(t => t.nefesTeknik = e)} allowNull />
            </CsmGenericGroupBox>
        </Cell>
    </Columns>

    return <Rows flex style={{ minWidth: minWidth }}>
        <Rows>
            <Columns hasLightBottomBorder pb={10} mb={10}>
                <Columns width={400}>
                    {uygunlukVeYorumContent}
                </Columns>
                <Columns width={750}>
                    {inputlarContent}
                </Columns>
            </Columns>
            <Columns>
                <Rows width={250}>
                    {legendContent}
                </Rows>
                <Rows width={250} ml={150}>
                    {ogrenmeZorlukStatContent}
                </Rows>
                <Rows>
                    {soylemeZorlukStatContent}
                </Rows>
                <Rows>
                    {/* <Radar
                        id="osman"
                        options={{
                            scales: {
                                r: {
                                    backgroundColor: BusinessHelper.SarkiZorluk.GrandientColor,
                                    ticks: { display: false },
                                    angleLines: { display: false },
                                    suggestedMin: 0,
                                    suggestedMax: 10
                                }
                            }
                        }}
                        data={{
                            labels: [
                                'Eser Uzunluğu',
                                'Eser Dili',
                                'Armoni/Ton',
                                'Melodi',
                                'Divizi',
                                'Ses Sınırı',
                                'Nüans',
                                'Duygu',
                            ],
                            datasets: [{
                                label: 'My Dataset',
                                data: [currentStats.eserUzunluk, currentStats.eserDil, currentStats.armoni, currentStats.melodi, currentStats.divizi, currentStats.sesSinir, currentStats.nuans, currentStats.duygu],
                                fill: true,
                                backgroundColor: 'rgba(255, 99, 132, 1)',
                                borderColor: 'rgb(255, 99, 132)',
                                pointBackgroundColor: 'rgb(255, 99, 132)',
                                pointBorderColor: '#fff',
                                pointHoverBackgroundColor: '#fff',
                                pointHoverBorderColor: 'rgb(255, 99, 132)'
                            }]
                        }} /> */}
                </Rows>
            </Columns>
        </Rows>
        {guncellenebilir ?
            <Columns mt={10}>
                <Button color="error" variant="contained" onClick={() => closer(null)} style={{ flex: 1, margin: 10, marginLeft: 0 }}>
                    {appIcons.Popup.iptal}
                    {genelDurumHelper.translate("İptal")}</Button>
                <Button color="success" variant="contained" onClick={() => zorlukKaydet()} style={{ flex: 1, margin: 10, marginRight: 0 }}>
                    {appIcons.Popup.tamam}
                    {genelDurumHelper.translate("Kaydet")}</Button>
            </Columns>
            :
            <Columns mt={10}>
                <Button color="info" variant="contained" onClick={() => closer(null)} style={{ flex: 1, margin: 10, marginLeft: 0 }}>
                    {appIcons.Popup.tamam}
                    {genelDurumHelper.translate("Tamam")}</Button>
            </Columns>
        }
    </Rows>
}

function StatLine(props: { title: string, note?: string, value: number | undefined, ortalama?: boolean }) {
    const hasValue = !(props.value === undefined || Number.isNaN(props.value));

    return <Columns>
        <Cell style={{ textAlign: "right" }}>
            <CsmText bold={props.ortalama}>{props.title}: </CsmText>
        </Cell>
        <Cell ml={5}>
            <CsmText bold style={{ color: appColors.SECONDARY }}>{!hasValue ? "-" : props.value!.toFixed(1)}</CsmText>
        </Cell>
        <Cell ml={5} mt={1}>
            <CsmText bold style={{ color: hasValue ? appColors.SECONDARY : undefined }} note>{props.note}</CsmText>
        </Cell>
    </Columns>
}

function LinearBoxWithText(props: { style?: CSSProperties, title: string, percent: number }) {
    return <Columns style={props.style}>
        <CsmGradientProgress
            width={100}
            height={16}
            style={{ flex: 1, height: "16px", borderRadius: "8px" }}
            value={props.percent} />
        <CsmText style={{ width: "100px" }}>{props.title}</CsmText>
    </Columns>
}

export default SarkiZorlukSarkiPopupEditor;